import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'

export const warningQuartersInconsistencyMsg = getFormedEltTranslation('quarters-sum-warning')
